import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-permission-flow',
  templateUrl: './permission-flow.component.html',
  styleUrls: ['./permission-flow.component.scss']
})
export class PermissionFlowComponent implements OnInit {
  private static readonly flows = {
    administration: {
      users: [
        "adminUsers",
        "showDocumentsPendingDrivers",
        "disableEnableUsers",
        "disableEnableDriver",
        "setupMonitorIntegration",
        "activateByScore",
        "updateVehicle",
        "changeRole",
        "editSimpleRegimen",
        "paymentBalance"
      ],
      termsAndConditions: [
        "adminTerms",
        "createTermsConditions"
      ],
      cities: [
        "adminCities",
        "updateCity",
        "linkCities",
        "addSubCities",
        "deleteSubCities"
      ],
      vehicles: [
        "adminVehicles",
        "validateDocumentsPendingDrivers",
        "downloadFileRegistreBank",
        "createVehicle",
        "activateVehicle",
        "updateBankAdvance",
        "updateBankBalance",
        "validateAndRemarkVehicleReferences",
        "showCreateGps",
        "showDeleteGps",
        "modifyBasicFieldsUser",
        "validateVehicleDocuments",
        "editAdminVehicle",
        "editOwnerVehicle",
        "editGpsVehicle",
        "showSecurityAnalysis",
        "manageSecurityStudy",
        "forceVehicleActivation",
        "deactivateVehicle",
        "editReferencesVehicle"
      ],
      trailers: [
        "adminTrailers"
      ],
      companies: [
        "adminCompanies",
        "createCompany",
        "createCostCenter",
        "updateCompany",
        "createEmailCompany",
        "deleteEmailCompany",
        "truoraConfiguration",
      ],
      roles: [
        "createRoles",
        "updateRoles",
        "adminRoles",
        "changeRolNotifications"
      ],
      modules: [
        "adminModules"
      ]
    },
    payments: {
      approve: [],
      pay: [
        "paymentCargo",
        "paymentExtraAdvance",
        "paymentAdvance"
      ],
      billing: [

      ],
      pastDue: [
        "adminReceivable",
        "createReceivable",
        "deleteReceivable",
        "viewPaymentsReceivables"
      ],
      files: [
        "generateAccountingFiles"
      ]
    },
    cargo: {
      reports: [],
      create: [],
      negotiationb2b: [],
      request: [],
      tracking: [],
      route: [],
      scheduled: [],
      negotiation: [],
      finished: []
    },
    guide: {
      create: [],
      generate: [],
      tracking: []
    },
    points: {
      create: [],
      list: []
    },
    routes: {
      routes: [],
      sites: []
    },
    settings: {
      password: [],
      terms: [],
      privacity: [],
      policies: [],
      habeasData: [],
      manifestAttachments: [],
      basc: [],
      fastPayment: []
    },
    support: {
      tickets: []
    },
    monitoring: {
      logging: []
    },
    analytics: {
      operations: [],
      deliveries: []
    }
  };

  constructor() { }

  ngOnInit() {
  }

}
